import _ from 'lodash';
import React from 'react';
import Helmet from 'react-helmet';
import classnames from 'classnames';
import { routes, url } from 'oo-routes';
import config from 'oo-config';

import http from 'sp-components/util/http';
import Page from 'sp-components/components/Page';
import Radio from 'sp-components/components/Radio';
import Message from 'sp-components/components/Message';
import {PERSONAS} from 'oo-components/utils/user';

import {validateUserRegistration} from '../../util';
import './styles';

const PERSONAS_SELECTIONS = [
  {
    display: 'E-commerce storeowner',
    value: PERSONAS.ECOMMERCE,
  },
  {
    display: 'Promotional products distributor',
    value: PERSONAS.PROMOTIONAL,
  },
  {
    display: 'Other',
    value: PERSONAS.OTHER,
  },
];

const SALES_SELECTIONS = [
  {
    display: 'Less than $250,000',
    value: 'less-than-250k',
  },
  {
    display: '$250,000 to $500,000',
    value: '250k-500k',
  },
  {
    display: '$500,000 to $1,000,000',
    value: '500k-1m',
  },
  {
    display: 'Over $1,000,000',
    value: 'over-1m',
  },
];

const PRINT_TYPE_SELECTIONS = [
  {
    display: 'Screenprint',
    value: 'screenprint',
    imageUrl: require('../../assets/images/screenprint-tshirt-white-design.png'),
  },
  {
    display: 'DTG',
    value: 'dtg',
    imageUrl: require('../../assets/images/dtg-tshirt-white-design.png'),
  },
  {
    display: 'Embroidery',
    value: 'embr',
    imageUrl: require('../../assets/products/hat.jpg'),
  },
  {
    display: 'Posters',
    value: 'poster',
    imageUrl: require('../../assets/images/poster-design.png'),
  },
  {
    display: 'Sublimation',
    value: 'sublimation',
    imageUrl: require('../../assets/images/mug-white-design.png'),
  },
];

const TERMS_URL = 'https://scalablepress.com/company/terms';

function loadIntlInput() {
  const phoneInputField = document.querySelector("#phone");
  const phoneInput = window.intlTelInput(phoneInputField, {
    utilsScript:
      "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js",
  });
  window.phoneInput = phoneInput;
}

export default class RegisterPage extends Page {
  state = {
    form: {
      printTypes: _.reduce(PRINT_TYPE_SELECTIONS, (printTypes, selection) => {
        const newPrintTypes = printTypes;
        newPrintTypes[selection.value] = false;
        return newPrintTypes;
      }, {}), // Evalueates to { dtg: false, embr: false, etc...}
    },
    phoneValidation: {},
    errors: {},
  }

  clearMessage = () => () => this.setState({ message: null })


  submitPhoneValidation = () => (event) => {
    event.preventDefault();
    if (!phoneInput.isValidNumber()) {
      return this.setState({ message: {error: "Invalid phone number"}});
    }
    const phoneNumber = phoneInput.getNumber();
    const form = Object.assign({}, this.state.form, { 'phone': phoneNumber });

    this.setState({ phoneValidationLoading: true, form});
    http.post(url('website', routes.website.auth.twilio.createVerificationSms), { body: { phone: phoneNumber } }, (err, result) => {
      this.setState({ phoneValidationLoading: false, validationStarted: true });
    });
  }

  updateField = field => (event) => {
    const form = Object.assign({}, this.state.form, { [field]: event.target.value });
    this.setState({ form });
  }

  updateFieldValue = field => (value) => {
    const form = Object.assign({}, this.state.form, { [field]: value });
    this.setState({ form });
  }

  togglePrintType = field => () => {
    const form = Object.assign({}, this.state.form);
    Object.assign(form.printTypes, { [field]: !form.printTypes[field] });
    this.setState({ form });
  }

  submit = form => () => {
    this.setState({ loading: true });
    const errors = validateUserRegistration(form);
    if (Object.keys(errors).length > 0) return this.setState({ errors, loading: false });

    this.setState({ errors, message: null });
    return http.post(url('website', routes.website.auth.register, Object.assign({}, this.props.location.query)), { body: form }, (err, result) => {
      if (err || !result) {
        const message = { error: err.message || err || 'Unknown error communicating with server' };
        return this.setState({ loading: false, message });
      }

      if (Appcues) {
        Appcues.identify(result._id, {
          name: result.name,
          email: result.email,
          created_at: result.createdAt,
        });
        Appcues.track("registration", {
          persona: this.state.form.persona,
          email: this.state.form.email,
          sales: this.state.form.sales,
        });
      }
      if (fbq) {
        fbq('track', 'CompleteRegistration');
      }

      window.location.href = url('website', routes.website.auth.success, { redirect: url('manager', routes.manager.new) });
      return this.setState({ message: { success: 'Successfully logged in, redirecting...' } });
    });
  }

  componentDidMount() {
    loadIntlInput();
  }

  render() {
    const { form, errors, message, loading } = this.state;
    return (
      <div className="RegisterPage">
        <Helmet
          title="Register"
        />
        <div className="ui container p-t-4 p-b-4">
          <div className="center-aligned">
            <h1>REQUEST AN ACCOUNT</h1>
            <p className="fs-2">Get started with a Scalable Press account.</p>
          </div>
          <div className="p-v-2" />
            <div className="ui centered grid">
              <div className="ui nine wide computer twelve wide tablet twelve wide mobile column">
                <div className="ui raised segments">
                  <div className="ui segment p-h-2 step-header">
                    <p className="fs-3">User Details</p>
                  </div>
                  <div className="ui segment p-h-2">
                    <div className="ui form">
                      {message &&
                        <div className="m-v-1">
                          <Message
                            message={message}
                            closable
                            dismiss={this.clearMessage()}
                          />
                        </div>}
                      {Object.keys(errors).length > 0 &&
                        <div className="ui message error">
                          <div className="header">Please fix these issues:</div>
                          <ul className="list">
                            {
                              _.map(errors, (error, field) => (
                                <li key={field}>{error}</li>
                              ))
                            }
                          </ul>
                        </div>
                      }
                      <div className="two fields">
                        <div className={classnames('field', { error: errors.first_name })}>
                          <input type="text" onChange={this.updateField('first_name')} placeholder="First Name" />
                        </div>
                        <div className={classnames('field', { error: errors.last_name })}>
                          <input type="text" onChange={this.updateField('last_name')} placeholder="Last Name" />
                        </div>
                      </div>
                      <div className={classnames('field', { error: errors.email })}>
                        <input type="text" onChange={this.updateField('email')} placeholder="Email" />
                      </div>
                      <div className="two fields">
                        <div className={classnames('field', { error: errors.password })}>
                          <input type="password" onChange={this.updateField('password')} placeholder="Choose a password" />
                        </div>
                        <div className={classnames('field', { error: errors.confirm })}>
                          <input type="password" onChange={this.updateField('confirm')} placeholder="Password, again" />
                        </div>
                      </div>
                      <div className={classnames('field', { error: errors.company })}>
                        <input type="text" placeholder="Company Name" />
                      </div>
                      <div className="two fields">
                        <div className="field">
                          <div className="container">
                            <form id="login" onSubmit={this.submitPhoneValidation()}>
                              <input id="phone" type="tel" onChange={this.updateField('phone')} name="phone" style={{paddingLeft: "3.25rem"}} />
                              {(!this.props.location.query.internalEmployee && !this.props.location.query.onboard) &&
                                <input type="submit" value="Get code" style={{padding: "0.75rem", verticalAlign: "bottom", marginLeft: "0.5rem"}}/>
                              }
                            </form>
                          </div>

                        </div>
                        {this.state.validationStarted &&
                          <div className="field">
                            <input type="text" onChange={this.updateField('phoneCode')} placeholder="Phone validation code" />
                          </div>
                        }
                      </div>
                    </div>
                  </div>

                  <div className="ui segment p-h-2">
                    <button
                      onClick={this.submit(form)}
                      className={classnames('ui primary button m-b-2 create-account-button', { loading })}
                    >
                      Create Account
                    </button>
                    <span className="secondary-text m-l-1">
                      By creating an account, you are agreeing to the <a href={TERMS_URL}>terms and conditions</a>
                    </span>
                    <div className="bottom-aligned">
                      <span className="secondary-text">
                        Already have an account? <a href={url('website2', routes.website2.home.auth.login)}>Login</a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/pages/RegisterPage/index.jsx